import httpUtil from '../assets/script/utils/http'
import config from '../assets/script/config'

const state = {};

const mutations = {};


const actions = {
  AGetFriendship(ctx, params) {
    return httpUtil.get("/course/Friendship", params)
  },
};


export default {
  namespaced: true,
  state,
  mutations,
  actions
};
